import axios from 'axios';

const COOKIE_DOMAIN = '.shopimind.com';
const COOKIE_BASE_FLAGS = `Domain=${COOKIE_DOMAIN}; Path=/; SameSite=Lax; Secure`;

export const authApi = axios.create({
  baseURL: process.env.VUE_APP_AUTH_API_URL,
  withCredentials: true,
});

export function writeAuthCookies(token: string, shopVersion: 'v4' | 'v5' = 'v4'): void {
  document.cookie = `api_token_v2=${token}; ${COOKIE_BASE_FLAGS}`;
  document.cookie = `spm_platform_version=${shopVersion}; ${COOKIE_BASE_FLAGS}`;
}

export function clearAuthCookies(): void {
  document.cookie = `api_token_v2=; ${COOKIE_BASE_FLAGS}; Max-Age=0`;
  document.cookie = `spm_platform_version=; ${COOKIE_BASE_FLAGS}; Max-Age=0`;
}
